export default "__VITE_ASSET__D0Gni_N5__"